/** At or above this share of correct answers a score reads as healthy. */
const GOOD_SCORE_THRESHOLD = 70;
/** Below this one it reads as a problem — the same 50% the per-question bars use. */
const FAIR_SCORE_THRESHOLD = 50;

export type ScoreTone = 'good' | 'fair' | 'poor' | 'neutral';

/**
 * How a participant's score reads at a glance, so the host can spot whoever is falling
 * behind without going through every figure.
 *
 * A session with nothing autocorrective resolved scores everyone 0 / 0, which is not a bad
 * result — it is no result — so it stays uncoloured instead of painting the class red.
 */
export const getScoreTone = (
  correctAnswers: number,
  totalQuestions: number,
): ScoreTone => {
  const percentage =
    totalQuestions === 0 ? undefined : (correctAnswers / totalQuestions) * 100;

  if (percentage === undefined) {
    return 'neutral';
  }

  if (percentage >= GOOD_SCORE_THRESHOLD) {
    return 'good';
  }

  return percentage >= FAIR_SCORE_THRESHOLD ? 'fair' : 'poor';
};
